import moment from 'moment';
import 'moment/locale/id';

export default function formatDate(time) {
  moment.locale('id');

  const $dateObject = typeof time === 'number' ? moment.unix(time) : moment(time);

  return $dateObject.format('LL');
}



// WEBPACK FOOTER //
// ./src/utils/formatDate.js